export const BODY_SKELETON_TEST_ID = 'body-skeleton'
export const CAPTION_SKELETON_TEST_ID = 'capcion-skeleton'
